const initialState: sage.state.ITeams = {
    invitedTeams: null,
    invitedTeamsStatus: "none",
    memberTeams: null,
    memberTeamsStatus: "none",
    createTeamStatus: "none",
    teamLookup: {},
    teamLookupStatus: {},
    teamMembersLookup: {},
    teamMembersLookupStatus: {},
    teamInviteesLookup: {},
    teamInviteesLookupStatus: {},
    createTeamInviteStatus: "none",
};

export default function teams(
    state: sage.state.ITeams = initialState,
    action: sage.actions.team.ReducerTypes
): sage.state.ITeams {
    switch (action.type) {
        case "com.sage.actions.teams.ISetInvitedTeams":
            return {
                ...state,
                invitedTeams: action.teams,
            };
        case "com.sage.actions.teams.ISetInvitedTeamsStatus":
            return {
                ...state,
                invitedTeamsStatus: action.status,
            };
        case "com.sage.actions.teams.ISetMemberTeams":
            return {
                ...state,
                memberTeams: action.teams,
                teamLookup: action.teams.reduce((prev, curr) => {
                    prev[curr.id] = curr;
                    return prev;
                }, state.teamLookup),
            };
        case "com.sage.actions.teams.ISetMemberTeamsStatus":
            return {
                ...state,
                memberTeamsStatus: action.status,
            };
        case "com.sage.actions.teams.ISetCreateTeamStatus":
            return {
                ...state,
                createTeamStatus: action.status,
            };
        case "com.sage.actions.teams.ISetTeam":
            return {
                ...state,
                teamLookup: {
                    ...state.teamLookup,
                    [action.team.id]: action.team,
                },
            };
        case "com.sage.actions.teams.ISetTeamStatus":
            return {
                ...state,
                teamLookupStatus: {
                    ...state.teamLookupStatus,
                    [action.teamId]: action.status,
                },
            };
        case "com.sage.actions.teams.ISetTeamMembersStatus":
            return {
                ...state,
                teamMembersLookupStatus: {
                    ...state.teamMembersLookupStatus,
                    [action.teamId]: action.status,
                },
            };
        case "com.sage.actions.teams.ISetTeamMembersTeams":
            return {
                ...state,
                teamMembersLookup: {
                    ...state.teamMembersLookup,
                    [action.teamId]: action.users,
                },
            };
        case "com.sage.actions.teams.ISetTeamInviteesTeams":
            return {
                ...state,
                teamInviteesLookup: {
                    ...state.teamInviteesLookup,
                    [action.teamId]: action.users,
                },
            };
        case "com.sage.actions.teams.ISetTeamInviteesStatus":
            return {
                ...state,
                teamInviteesLookupStatus: {
                    ...state.teamInviteesLookupStatus,
                    [action.teamId]: action.status,
                },
            };
        case "com.sage.actions.teams.ISetCreateTeamInviteStatus":
            return {
                ...state,
                createTeamInviteStatus: action.status,
            };
        case "com.sage.actions.team.IClear":
            return initialState;
        default:
            return state;
    }
}
